module.exports = __webpack_public_path__ + "zl18-c141d4f4.png";